import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { Season } from "@busy-human/hxp-library";
import { type DataInstance } from "@busy-human/gearbox";
import { doc, getDoc } from 'firebase/firestore';
import { reactive, ref, watch, computed, onMounted } from 'vue';
import {useSeasons} from '@/store/seasons';
import { useSeasonBuilders } from "@/store/builder-seasons";
import { useAuth } from "@/store/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'season-dropdown',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const seasonStore = useSeasons();
const auth = useAuth();
const builderSeasons = useSeasonBuilders();

// eslint-disable-next-line no-undef
const model = _useModel<string>(__props, "modelValue");

const props = __props;

const seasonOptions = ref(new Map());

const loadingSeasons = ref(true);

const seasonsArray = computed(() => [...seasonOptions.value.keys()].map((sId: string) => ({$id: sId, ...seasonOptions.value.get(sId)} as DataInstance<Season.Model>)));

onMounted(() => {
	const seasonsMap = seasonStore.getSeasons();
	if(auth.isAdmin){
		seasonOptions.value = seasonsMap ;
	}else{
		const seasonOptionIds = [...seasonsMap.keys()];
		seasonOptionIds.forEach((s) => {
			if(builderSeasons.accountVisableSeasons.includes(s)){
				seasonOptions.value.set(s, seasonsMap.get(s));
			}
		});
	}
	
	if(!model.value) {
		model.value = seasonStore.current?.$id;
	};
	loadingSeasons.value = false;
});

watch(() => model.value, () => {
	if(model.value) {
		seasonStore.setSeasonOverride(model.value);
		if(seasonStore.current?.isCurrent) seasonStore.clearSeasonOverride();
	}
});


const __returned__ = { seasonStore, auth, builderSeasons, model, props, seasonOptions, loadingSeasons, seasonsArray, get Season() { return Season }, get doc() { return doc }, get getDoc() { return getDoc }, reactive, ref, watch, computed, onMounted, get useSeasons() { return useSeasons }, get useSeasonBuilders() { return useSeasonBuilders }, get useAuth() { return useAuth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})